import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":"","ma-0":"","pa-0":""}},[_c('HelloWorld'),_c(VContainer,{staticClass:"d-flex flex-column flex-md-row flex-lg-row flex-xl-row",attrs:{"fluid":"","ma-0":"","pa-0":"","xs12":"","md12":""}},[_c(VFlex,{attrs:{"xs12":"","md7":"","lg7":""}},[_c('AboutFacig')],1),_c(VFlex,{attrs:{"xs12":"","md5":"","lg5":"","flex-column":"","secondary":""}},[_c('MidiaArticles'),_c('SocialMidia')],1)],1),_c('Apareca')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }